import React, { useEffect, useRef, useState } from 'react';
import Modal from '@mos-cat/modal';
import { Heading } from '@mos-cat/typography';
import './InfoAboutServiceModal.pcss';
import { aboutServiceCollapsible } from '../../../constants/iterableTexts';

function InfoAboutServiceModal(): JSX.Element {
  const [isVisible, setModalVisible] = useState(false);
  const [isFloatLink, setFloatLink] = useState(false);
  const [activeAnchor, setActiveAnchor] = useState<string | null>(null);
  const navRef = useRef<HTMLDivElement>(null);

  const scrollWatcher = ({ target }) => {
    const navigationPadding =
      navRef && navRef.current
        ? navRef.current.getBoundingClientRect().height
        : 300;
    if (target && target.scrollTop > navigationPadding) {
      setFloatLink(true);
    }
    if (target && target.scrollTop <= navigationPadding) {
      setFloatLink(false);
    }
  };

  const toggleScrollWatcher = (unsubscribe?: boolean) => {
    const target = document.querySelector(
      '.InfoAboutServiceModal .Modal__content'
    );
    if (target && isVisible) {
      target.addEventListener('scroll', scrollWatcher);
    }
    if (target && (!isVisible || unsubscribe)) {
      target.removeEventListener('scroll', scrollWatcher);
    }
  };

  const scrollToAnchor = (anchor: string) => {
    const element = document.querySelector(anchor);

    if (!element) return;
    element.scrollIntoView({ block: 'center', behavior: 'smooth' });
  };

  useEffect(() => {
    const unsubscribe = () => {
      setActiveAnchor(null);
    };
    if (activeAnchor === null) {
      return unsubscribe;
    }
    scrollToAnchor(activeAnchor);

    return unsubscribe();
  }, [activeAnchor]);

  useEffect(() => {
    toggleScrollWatcher();

    return () => {
      toggleScrollWatcher(true);
    };
  }, [isVisible]);

  const navigationBlockContent = aboutServiceCollapsible.map(
    ({ title, anchor }, i) => {
      const key = `anchor${i}_${title}`;
      return (
        <div
          key={anchor}
          className="InfoAboutServiceModal__Navigation-link-wrapper"
        >
          <button
            className="mos-link InfoAboutServiceModal__Navigation-link"
            onClick={() => setActiveAnchor(`#${anchor}`)}
            key={key}
          >
            {title}
          </button>
        </div>
      );
    }
  );
  const infoBlockContent = aboutServiceCollapsible.map(
    ({ anchor, title, text }, i) => {
      const key = `id${i}_${title}`;
      return (
        <div key={key} className="InfoAboutServiceModal__Info-block">
          <div className="InfoAboutServiceModal__Info-title" id={anchor}>
            {title}
          </div>
          <div className="InfoAboutServiceModal__Info-text">{text}</div>
        </div>
      );
    }
  );

  const headerContent = (
    <Heading level={3} className="InfoAboutServiceModal__Title">
      <span id="InfoAboutServiceTitle">Официальная информация</span>
    </Heading>
  );

  const scrollLinkClass = `InfoAboutServiceModal__ScrollTop ${
    isFloatLink ? 'fixed' : ''
  }`;
  const overlayScrollClass = `InfoAboutServiceModal__ScrollTop-overlay ${
    isFloatLink ? 'fixed' : ''
  }`;
  const infoClassName = `InfoAboutServiceModal__Info ${
    isFloatLink ? 'pushed' : ''
  }`;

  return (
    <React.Fragment>
      <button
        className="mos-link InfoAboutServiceModal__Link"
        onClick={() => setModalVisible(true)}
      >
        Информация по услуге
      </button>
      <Modal
        headerContent={headerContent}
        visible={isVisible}
        onClose={() => setModalVisible(false)}
        className="InfoAboutServiceModal"
      >
        <div className={overlayScrollClass} />
        <div className="InfoAboutServiceModal__Navigation" ref={navRef}>
          {navigationBlockContent}
          <div className={scrollLinkClass}>
            <a
              className="InfoAboutServiceModal__ScrollTop-link"
              onClick={() =>
                setActiveAnchor('.InfoAboutServiceModal__Navigation')
              }
            >
              К оглавлению
            </a>
          </div>
        </div>
        <div className={infoClassName}>{infoBlockContent}</div>
      </Modal>
    </React.Fragment>
  );
}

export default InfoAboutServiceModal;
